var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandleWithCare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 30,
    viewBox: "0 0 47 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.451 35.41a5.621 5.621 0 0 1-2.382-.524l-8.28-3.892-6.284 1.712a.476.476 0 1 1-.248-.92l6.44-1.758a.46.46 0 0 1 .312 0l8.446 4.03a4.701 4.701 0 0 0 3.634.147l18.152-6.771a1.921 1.921 0 0 0-1.104-3.68l-12.144 2.944a.368.368 0 0 1-.175 0l-2.668-.35c-.27.032-.54.032-.81 0l-5.75-.837a.47.47 0 0 1-.395-.524.47.47 0 0 1 .515-.387l6.44.838A2.484 2.484 0 0 0 30.2 23.68a2.447 2.447 0 0 0-.23-1.932 2.475 2.475 0 0 0-1.545-1.168L18.36 18.04 7.514 21.28a.479.479 0 0 1-.267-.92l10.967-3.276a.57.57 0 0 1 .248 0l10.194 2.54a3.386 3.386 0 0 1 2.438 4.314 3.294 3.294 0 0 1-1.187 1.73l.92.128 12.061-2.88a2.834 2.834 0 0 1 1.647 5.374l-18.124 6.77a5.75 5.75 0 0 1-1.96.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M7.376 35.843H.835a.46.46 0 0 1-.322-.129.45.45 0 0 1-.138-.331v-17.82a.46.46 0 0 1 .46-.46h6.532a.46.46 0 0 1 .46.46v17.82c0 .25-.2.455-.45.46zm-6.081-.92h5.621v-16.9H1.295v16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.478 24.398a.46.46 0 0 1-.46-.46V1.858H15.94v16.56a.46.46 0 1 1-.92 0V1.398a.46.46 0 0 1 .46-.46h24.997a.46.46 0 0 1 .46.46v22.54a.47.47 0 0 1-.46.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.885 7.948h-8.087a.46.46 0 0 1-.46-.46v-6.09a.46.46 0 1 1 .92 0v5.63h7.167v-5.63a.46.46 0 1 1 .92 0v6.09a.46.46 0 0 1-.46.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.846 20.258a.46.46 0 0 1-.46-.46V7.488a.46.46 0 1 1 .92 0v12.31a.46.46 0 0 1-.46.46z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandleWithCare);
export default __webpack_public_path__ + "static/media/handle-with-care.f1821c2136978d1b7c5d820cf0273c56.svg";
export { ForwardRef as ReactComponent };